import {
    AbstractControl,
    ValidationErrors,
    ValidatorFn
} from '@angular/forms';

export class OpeningsValidationUtils {

    static readonly MAX_OPENINGS = 9999;

    static openingsValidator(): ValidatorFn {

        return (
            control: AbstractControl
        ): ValidationErrors | null => {

            const value = control.value;

            if (
                value === null ||
                value === undefined ||
                value === ''
            ) {
                return null;
            }

            // Integer only
            if (!/^[1-9]\d*$/.test(value.toString())) {
                return { invalidOpenings: true };
            }

            const openings = Number(value);

            // Min value check
            if (openings < 1) {
                return { invalidOpenings: true };
            }

            // Max value check
            if (openings > this.MAX_OPENINGS) {
                return { invalidOpenings: true };
            }

            return null;
        };
    }

    static getOpeningsError(
        control: AbstractControl | null
    ): string {

        if (
            !control ||
            !control.errors ||
            !control.touched
        ) {
            return '';
        }

        if (control.errors['required']) {
            return 'Number of Openings is required.';
        }

        if (control.errors['invalidOpenings']) {
            return 'Please enter a valid number of openings.';
        }

        return '';
    }
}